import React, { Component } from 'react';

export default class PureCanvas extends Component {
  shouldComponentUpdate() { return false; }

  saveRef(node) {
    this.props.contextRef(node.getContext('2d'));
    this._canvas = node;
  }

  render() {
    const { width, height } = this.props;
    return (
      <canvas width={width} height={height}
        ref={node => node ? this.saveRef(node) : null}
      />
    );
  }
}

/*
      <canvas width={width} height={height}
        ref={node => node ? this.props.contextRef(node.getContext('2d')) : null}
      />
 */